import { render } from "./Contact.vue?vue&type=template&id=248ef94b&scoped=true"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=248ef94b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248ef94b"]])

export default __exports__